import RadioField from './radio'

export default RadioField


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-formit-fields/src/components/radio/index.js
// module id = null
// module chunks = 